import axios from 'axios';
const header = {
  'Content-Type': 'application/json',
}

/*****************************First Fetched Masked Email and Mobile**************************** */
export const getMaskedPhoneAndEmail = async (activityId, eventCode, coapplicant) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_MASK_PHONE_AND_EMAIL_API,
        "activityid": `${activityId}`,
        "coapplicant": `${coapplicant}`,
        "eventcode": `${eventCode}`,
        "lappType": "customer_doc_upload"
      },
      "orgId": process.env.REACT_APP_ORGID,
      "data": {
        "lappBody": {}
      }
    })
  }
  return await axios(config)
}
/************************************************************************************************ */

/*****************Note :- uploadfile OperationType axios is handled in App.js file . Function Name is sendFileToTemporaryLocation()****************************************************************************** */



export const sendOtpToMobileNumber = async (activityId, coapplicant) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_CONSENT_MOBILE_OTP_INTEGRATION_API,
        "type": "sendMobileOTP"
      },
      "orgId": process.env.REACT_APP_ORGID,

      "data": {
        "lappBody": {
          activityId: activityId,
          applicantType: coapplicant,
          type: 'documentUpload'
        }
      }
    })
  }
  return await axios(config);
}


export const verifyOtpFromApi = async (activityId, coapplicant, otp) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_CONSENT_MOBILE_OTP_INTEGRATION_API,
        "type": "verifyMobileOTP"
      },
      "orgId": process.env.REACT_APP_ORGID,

      "data": {
        "lappBody": {
          activityId: activityId,
          applicantType: coapplicant,
          type: 'documentUpload',
          otp: otp,
        }
      }
    })
  }

  return await axios(config);
}


export const logVerificationResponse = async (activityDetails, status, applicantType, token) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_CUSTOMER_DOCUMENT_UPLOAD_API,
        "operationType": "logVerificationDetails"
      },
      "orgId": process.env.REACT_APP_ORGID,

      "data": {
        "lappBody": {
          activityDetails: activityDetails,
          otpStatus: status,
          "tokenDetails": {
            token: `${token}`,
            activityId: `${activityDetails.activityid}`,
            coApplicant: `${applicantType}`,
            type: 'documentUpload',
          }
        }
      }
    })
  }

  console.log("config >>>", JSON.stringify(config))

  return await axios(config)
}

export const getApplicantDetailsForDocumentUpload = async (requestedActivityId, coapplicant, applicantType, token) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_CUSTOMER_DOCUMENT_UPLOAD_API,
        "activityid": `${requestedActivityId}`,
        "coapplicant": `${coapplicant}`,
        "operationType": "fetch"
      },
      "orgId": process.env.REACT_APP_ORGID,

      "data": {
        "lappBody": {
          "tokenDetails": {
            token: `${token}`,
            activityId: `${requestedActivityId}`,
            coApplicant: `${applicantType}`,
            type: 'documentUpload',
          }
        }
      }
    })
  }
  return await axios(config)
}

export const submitDocuments = async (body, activityDetails,applicantType,token) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": process.env.REACT_APP_ENVIRONMENT,
        "name": process.env.REACT_APP_CUSTOMER_DOCUMENT_UPLOAD_API,
        "operationType": "submit"
      },
      "orgId": process.env.REACT_APP_ORGID,

      "data": {
        "lappBody": {
          documentList: body,
          activityDetails: activityDetails,
          "tokenDetails": {
            token: `${token}`,
            activityId: `${activityDetails.activityid}`,
            coApplicant: `${applicantType}`,
            type: 'documentUpload',
          }
        }
      }
    })
  }

  return await axios(config);
}

